import { render, staticRenderFns } from "./DuplicateUser.vue?vue&type=template&id=4b2c02a8&"
import script from "./DuplicateUser.vue?vue&type=script&lang=js&"
export * from "./DuplicateUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports